module.exports = __webpack_public_path__ + "static/media/logo16a.16b9b05c.png";